import Globals from '@/config/Globals';
//
export default class APIDepartments {
  constructor(API) {
    this.api = API;
  }

  async getAll() {
    const req = await this.api.newBaseRequest('GET');
    req.path = Globals.APIPath_Departments;
    return await req.exec();
  }

  async getByID(departmentID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = Globals.APIPath_Department + departmentID;
    return await req.exec();
  }

  async create(departmentObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = Globals.APIPath_Department + Globals.URL_NewIndentifier;
    req.body = { ...departmentObj };
    return await req.exec();
  }

  async update(departmentObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = Globals.APIPath_Department + departmentObj.id;
    delete departmentObj.id;
    req.body = { ...departmentObj };
    return await req.exec();
  }

  async remove(departmentID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = Globals.APIPath_Department + departmentID;
    return await req.exec();
  }
}
